module.exports = __webpack_public_path__ + "static/media/veneto-village-12.fb039662.jpg";